module.exports = __webpack_public_path__ + "static/media/proj1_img9.94aa89bd.jpg";